import { render, staticRenderFns } from "./out-card-list.vue?vue&type=template&id=675da701&scoped=true"
import script from "./out-card-list.vue?vue&type=script&lang=js"
export * from "./out-card-list.vue?vue&type=script&lang=js"
import style0 from "./out-card-list.vue?vue&type=style&index=0&id=675da701&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675da701",
  null
  
)

export default component.exports